import { RECORD_EVENT_REQUEST } from './constants';

export const recordEvent = (eventName, payload) => ({
  type: RECORD_EVENT_REQUEST,
  eventName,
  payload
});
